import { useTranslation } from 'react-i18next';
import { ConfirmOptions } from '@utils/types/confirm-options.ts';
import Modal from '@components/atoms/modals/modal.tsx';
import Button from '@components/atoms/ui-kit/button.tsx';

type Props = ConfirmOptions & { open: boolean };

const Confirm = ({
  open,
  title,
  subtitle,
  confirmText,
  cancelText,
  type,
  onCancel,
  onConfirm
}: Props) => {
  const { t } = useTranslation();

  if (!open) return null;

  const confirmVariant = type === 'error' ? 'danger' : 'primary';

  return (
    <>
      <Modal
        isOpen={open}
        onClose={() => onCancel?.()}
        size="small"
        title={title ?? t('unsaved-changes')}
        caption={
          subtitle ??
          t('if-you-leave-you-will-lose-unsaved-changes-are-you-sure')
        }
        footerActions={[
          <Button
            onClick={() => onCancel?.()}
            label={cancelText ?? t('cancel')}
            size={'small'}
            variant={'smoke'}
          />,
          <Button
            type={'button'}
            onClick={() => onConfirm?.()}
            label={confirmText ?? t('confirm')}
            size={'small'}
            variant={confirmVariant}
          />
        ]}
        children={undefined}
      />{' '}
    </>
  );
};

export default Confirm;
